/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerDownLeftIcon16Light } from './ArrowDCornerDownLeftIcon16Light';
import { ArrowDCornerDownLeftIcon16Regular } from './ArrowDCornerDownLeftIcon16Regular';
import { ArrowDCornerDownLeftIcon16Solid } from './ArrowDCornerDownLeftIcon16Solid';
import { ArrowDCornerDownLeftIcon20Light } from './ArrowDCornerDownLeftIcon20Light';
import { ArrowDCornerDownLeftIcon20Regular } from './ArrowDCornerDownLeftIcon20Regular';
import { ArrowDCornerDownLeftIcon20Solid } from './ArrowDCornerDownLeftIcon20Solid';
import { ArrowDCornerDownLeftIcon24Regular } from './ArrowDCornerDownLeftIcon24Regular';
import { ArrowDCornerDownLeftIcon24Solid } from './ArrowDCornerDownLeftIcon24Solid';
import { ArrowDCornerDownLeftIcon32Regular } from './ArrowDCornerDownLeftIcon32Regular';
import { ArrowDCornerDownLeftIcon64Regular } from './ArrowDCornerDownLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerDownLeftIcon16Light,
        regular: ArrowDCornerDownLeftIcon16Regular,
        solid: ArrowDCornerDownLeftIcon16Solid,
    },
    20: {
        light: ArrowDCornerDownLeftIcon20Light,
        regular: ArrowDCornerDownLeftIcon20Regular,
        solid: ArrowDCornerDownLeftIcon20Solid,
    },
    24: {
        regular: ArrowDCornerDownLeftIcon24Regular,
        solid: ArrowDCornerDownLeftIcon24Solid,
    },
    32: {
        regular: ArrowDCornerDownLeftIcon32Regular,
    },
    64: {
        regular: ArrowDCornerDownLeftIcon64Regular,
    },
};
export var ArrowDCornerDownLeftIcon = forwardRef('ArrowDCornerDownLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
